import { Component } from "react";

// App-wide crash guardrail — turns any render/processing exception into a
// non-blocking recovery panel (+ a toast) instead of a white-screened site.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: null };
  }
  static getDerivedStateFromError(err) {
    return { err };
  }
  componentDidCatch(err, info) {
    console.error("ErrorBoundary caught", err, info);
    import("sonner").then(({ toast }) => toast.error("Something hiccuped — your work is safe.")).catch(() => {});
  }
  render() {
    if (this.state.err) {
      return (
        <div data-testid="error-boundary" className="grid min-h-[40vh] w-full place-items-center p-6 text-center">
          <div className="space-y-3">
            <p className="font-serif text-xl text-white">Something hiccuped</p>
            <p className="font-mono text-[11px] leading-relaxed text-white/60">Your saved work is safe. Try again, or reload the page.</p>
            <button onClick={() => this.setState({ err: null })} data-testid="error-retry"
              className="border-2 border-[#FFE08A] bg-[#FFE08A]/10 px-4 py-2 font-mono text-[11px] font-black uppercase tracking-widest text-[#FFE08A]">
              Try again
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
